// O TEXTO que o limite de erro mostra na tela quando uma tela quebra.
//
// Mora separado do componente por um motivo pratico deste projeto: o vitest roda
// em `environment: 'node'`, sem DOM, entao componente nenhum e testavel aqui. O
// que da para provar em teste unitario e o texto -- e ele e justamente a parte
// que decide se eu consigo consertar o defeito ou fico adivinhando.

export interface DadosDoErro {
  mensagem: string
  pilha: string | null
  versao: string
  endereco: string
  // A pilha de COMPONENTES que o React entrega no componentDidCatch. Vale mais
  // que a de execucao no pacote publicado: o React monta ela com `Function.name`
  // -- preservado pelo `keepNames` do build -- enquanto a de execucao vira
  // `index-abc.js:1:99999`, que nao nomeia tela nenhuma.
  componentes: string | null
}

// Sem a pilha inteira: no celular ela nao cabe na tela e empurra a mensagem --
// que e a linha que importa -- para fora do alcance da vista.
const LINHAS_DE_PILHA = 4
const COMPONENTES_MOSTRADOS = 4

export function textoDoRelatorio({
  mensagem,
  pilha,
  versao,
  endereco,
  componentes,
}: DadosDoErro): string {
  const partes = [
    // A mensagem primeiro, sempre: e a unica linha que costuma bastar.
    mensagem.trim() || 'Erro sem mensagem.',
    `versão ${versao}`,
    `tela ${endereco}`,
  ]
  const nomes = nomesDeComponentes(componentes)
  // De dentro para fora: o primeiro e quem quebrou, e os seguintes dizem onde
  // ele estava. A seta aponta para quem CONTEM.
  if (nomes) partes.push(`componentes ${nomes}`)
  const resumo = resumirPilha(pilha)
  if (resumo) partes.push(resumo)
  return partes.join('\n')
}

function nomesDeComponentes(componentes: string | null): string | null {
  if (!componentes) return null
  const achados = [...componentes.matchAll(/\bat ([A-Za-z0-9_$]+)/g)].map((m) => m[1])
  if (achados.length === 0) return null
  return achados.slice(0, COMPONENTES_MOSTRADOS).join(' ← ')
}

function resumirPilha(pilha: string | null): string | null {
  if (!pilha) return null
  const linhas = pilha
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l !== '')
  if (linhas.length === 0) return null
  return linhas.slice(0, LINHAS_DE_PILHA).join('\n')
}
